<div>
	<label class="label" for="addTags" *ngIf="label">
		{{ 'TAGS_PAGE.HEADER' | translate }}
	</label>
	<ng-select
		[items]="tags"
		[multiple]="multiple"
		bindLabel="name"
		appendTo="body"
		[loading]="loading"
		[addTag]="addTag"
		(change)="selectedTagsEvent.emit(this.selectedTags)"
		[(ngModel)]="selectedTags"
		[closeOnSelect]="false"
		id="addTags"
		[placeholder]="'MENU.TAGS' | translate"
	>
		<ng-template ng-option-tmp let-tag="item" let-tag$="item$">
			<ng-container *ngIf="multiple">
				<input type="checkbox" [ngModel]="tag$.selected" />
			</ng-container>
			<nb-badge
				[style.background]="tag.color"
				class="tag-color"
			></nb-badge>
			<span>{{ tag.name }}</span>
		</ng-template>

		<ng-template ng-label-tmp let-tag="item" let-clear="clear">
			<nb-badge
				class="tag-color tag-label"
				[style.background]="tag.color"
				[style.color]="backgroundContrast(tag.color)"
				text="X"
				(click)="clear(tag)"
			></nb-badge>
			<span>{{ tag.name }}</span>
		</ng-template>

		<ng-template ng-tag-tmp let-newTagName="searchTerm">
			<b>{{ 'TAGS_PAGE.ADD_NEW_TAG' | translate }}</b
			>: {{ newTagName }}
		</ng-template>
	</ng-select>
</div>
